export default __webpack_public_path__ + "static/superhero-winner@2x-418c34b027ede5d372a2b966873a6f9a.png";